import './styles.scss';

export default function generateImageCaptions() {
  const imagesArray = document.querySelectorAll(
    '.page-content img[title]:not([class="file-summary-icon"])'
  ) as NodeListOf<HTMLImageElement>;
  if (imagesArray.length > 0) {
    for (let index = 0; index < imagesArray.length; index++) {
      const imageTitle = imagesArray[index].getAttribute('title');
      if (imageTitle && imageTitle.length > 0) {
        attachCaptions(imagesArray, index);
      } else {
        noCaptions(imagesArray, index);
      }
    }
  }
}

function attachCaptions(
  imagesArray: NodeListOf<HTMLImageElement>,
  index: number
) {
  const imageTitle = imagesArray[index].getAttribute('title') ?? '';
  const imageContainerElem = document.createElement('div');
  const captionElem = document.createElement('p');

  const imageFloat = imagesArray[index].style.float;
  const imageWidth = imagesArray[index].width;
  const imageMargin = imagesArray[index].style.margin;

  imagesArray[index].style.margin = '0px';

  if (imagesArray[index].parentElement?.nodeName === 'A') {
    imagesArray[index].parentElement?.parentNode?.insertBefore(
      imageContainerElem,
      imagesArray[index].parentElement
    );
  } else {
    imagesArray[index].parentNode?.insertBefore(
      imageContainerElem,
      imagesArray[index]
    );
  }

  const imageContainerClasses = ['image-container', 'mb-4'];
  imageContainerElem.classList.add(...imageContainerClasses);

  const captionClasses = ['caption', 'px-3', 'py-2'];
  captionElem.classList.add(...captionClasses);

  // If the image was center-justified, add left/right auto margins to the container.
  if (imageMargin === '1em auto') {
    imageContainerElem.style.marginLeft = 'auto';
    imageContainerElem.style.marginRight = 'auto';
  }

  imageContainerElem.style.float = imageFloat;
  imageContainerElem.setAttribute('width', imageWidth.toString());
  imageContainerElem.style.width = imageWidth + 'px';

  if (imagesArray[index].parentElement?.nodeName == 'A') {
    imageContainerElem.appendChild(
      imagesArray[index].parentElement as HTMLElement
    );
  } else {
    imageContainerElem.appendChild(imagesArray[index]);
  }

  imageContainerElem.appendChild(captionElem);

  captionElem.innerHTML = imageTitle;

  if (imagesArray[index].style.float == '') {
    // imageContainerElem.style.margin = "0px auto";
  }

  if (imagesArray[index].style.float == 'left') {
    imageContainerElem.style.marginRight = '25px';
  }

  if (imagesArray[index].style.float == 'right') {
    imageContainerElem.style.marginLeft = '25px';
  }

  imagesArray[index].style.float = 'none';
}

function noCaptions(imagesArray: NodeListOf<HTMLImageElement>, index: number) {
  if (imagesArray[index].style.float == 'left') {
    imagesArray[index].style.margin = '5px 25px 10px 0px';
  }
  if (imagesArray[index].style.float == 'right') {
    imagesArray[index].style.margin = '5px 0px 10px 25px';
  }
}
